/* eslint-disable import/prefer-default-export */
export const ENTER_TYPE = () => ({
  wechat: 1,
  platform: 2,
});
